<template>
  <v-card class="pl-3 hc__rounded-card">
    <v-card-title>
      <h2 class="font-weight-thin hc__blue-text">{{question.name}}</h2>
    </v-card-title>

    <v-card-text class="subheading " v-html="question.content"></v-card-text>

    <v-card-actions>
      <v-layout row wrap class="eZwTmB">
        <v-flex xs12 md3>
          <div class="imagen-c">
            <v-img
              class="img"
              src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/helpcenter_img_01.png"
            ></v-img>
          </div>
        </v-flex>
        <v-flex xs12 md9 class="pl-4">
          <h2 class="font-weight-thin hc__blue-text">
            ¿Necesitas más ayuda?
          </h2>
          <v-flex class="subheading mt-1">
            Escríbenos y nos comunicaremos contigo.
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  props: {
    question: { type: Object, required: true }
  }
}
</script>
<style lang="css">
.eZwTmB {
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid rgb(225, 225, 225);
}


.hc__color-2 {
  color:#28385C !important
}

.hc__rounded-card{
  border-radius: 0.5rem
}
.imagen-c{
  height: 120px;
  margin:auto;
}
.img{
  top: -35px;
  margin:auto;
  height: 200px;
  width: 200px;
  }
</style>